import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M10 8v8","key":"svg-2"}]]

const IconNumber42Small = createReactComponent('outline', 'number-42-small', 'Number42Small', __iconNode);

export default IconNumber42Small;